import { Link } from "react-router-dom";
import WhatsAppLogo from "@/assets/whatsapp.png";

const WHATSAPP_CLAIM_URL =
  "https://wa.me/919324095283?text=Hi%2C%20I%20want%20to%20raise%20a%20request";

export default function HowItWorks() {
  return (
    <section className="tw-relative tw-bg-[#EDEDED] tw-py-10 tw-text-black tw-overflow-hidden md:tw-min-h-[600px] lg:tw-min-h-[752px]">
      {/* phone image sits behind the copy on md+; its lower edge is cropped as in the design */}
      <div className="tw-hidden md:tw-block tw-absolute tw-overflow-hidden md:tw-right-0 md:tw-bottom-0 md:tw-w-1/2 md:tw-h-[60%] lg:tw-left-[28.5%] lg:tw-top-5 lg:tw-bottom-auto lg:tw-w-[68%] lg:tw-h-[676px]">
        <img
          src="/LovePangolinFAQ/HowItWorks.png"
          alt="Claims Process on Phone"
          className="tw-w-full tw-h-full tw-object-cover tw-object-top"
        />
      </div>

      <div className="tw-relative tw-z-10 tw-w-[90%] md:tw-w-4/5 tw-mx-auto">
        <h2 className="tw-text-4xl md:tw-text-5xl md:tw-leading-[48px] tw-text-center tw-font-semibold">
          How it works
        </h2>

        <div className="tw-max-w-[471px] tw-pt-10 tw-flex tw-flex-col tw-gap-5 tw-items-start">
          <h3 className="tw-text-3xl tw-leading-9 tw-font-semibold">
            Easy claims, great service
          </h3>

          <p className="tw-text-lg tw-leading-7">
            Filing a claim is simple. Share a few details about what happened,
            and our team will review your claim and email you the details of
            your next steps.
          </p>

          <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-4">
            <Link
              to="/customer/claims"
              className="tw-rounded-full tw-border tw-border-black tw-px-6 tw-py-3 tw-text-black tw-no-underline hover:tw-bg-black hover:tw-text-white tw-transition-colors"
            >
              Start a Claim
            </Link>

            <a
              href={WHATSAPP_CLAIM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border tw-border-black tw-px-6 tw-py-3 tw-text-black tw-no-underline hover:tw-bg-black hover:tw-text-white tw-transition-colors"
            >
              <img
                src={WhatsAppLogo}
                alt="WhatsApp"
                width={20}
                height={20}
                className="tw-h-5 tw-w-5 tw-shrink-0 tw-object-contain"
              />
              Quick Claim
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
